'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { sendRequest } from '../actions';
import { getAuthType, getApiKey, getOAuthToken, getResponseStatus } from '../selectors';
import { AuthTypes, AuthTypePropType } from '../constants';
import ResponsiveRenderer from '../../../components/ResponsiveRenderer';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { RequestStatusPropType } from '../../../lib/models/RequestStatus';
import TryItPopover from './TryItPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TryIt extends Component {
  constructor(props) {
    super(props);
    this.getDefaultAuthDetails = () => {
      return {
        authType: this.props.selectedAuthType,
        apiKey: this.props.apiKey,
        oAuthToken: this.props.oAuthToken
      };
    };
    this.getDefaultState = () => ({
      authPopoverIsOpen: false,
      isConfirming: false,
      isUsingPreviousAuthDetails: false
    });
    this.getAuthDetailsAreSet = authDetails => {
      return AuthTypes.DEVELOPER_API_KEY === authDetails.authType && authDetails.apiKey || authDetails.authType === AuthTypes.OAUTH_TOKEN && authDetails.oAuthToken;
    };
    this.onCancelButtonClick = () => {
      this.setState(this.getDefaultState());
    };
    this.onSendRequestButtonClick = authDetails => {
      const {
        isConfirming,
        isUsingPreviousAuthDetails
      } = this.state;
      const needsConfirmation = this.doc.api.method !== 'get' && !isConfirming;
      if (needsConfirmation) {
        this.setState({
          isConfirming: true
        });
        return;
      }
      if (!authDetails || isUsingPreviousAuthDetails) {
        authDetails = this.getDefaultAuthDetails();
      }
      const {
        docId
      } = this.props;
      this.props.sendRequest({
        authDetails,
        docId
      });
      this.setState(this.getDefaultState());
    };
    this.onTestCallButtonClick = () => {
      const {
        docId,
        selectedAuthType
      } = this.props;
      const authDetails = this.getDefaultAuthDetails();
      if (selectedAuthType !== AuthTypes.NONE && !this.getAuthDetailsAreSet(authDetails)) {
        // We don't have the authentication details we need, open the popover so they can be set
        this.setState({
          authPopoverIsOpen: true
        });
      } else {
        if (this.doc.api.method === 'get') {
          // We have auth details and this is a GET method, so we can just make the test call now
          this.props.sendRequest({
            authDetails,
            docId
          });
        } else {
          // We have auth details but need confirmation before making the test call. Show the confirmation popover.
          this.setState({
            isConfirming: true,
            isUsingPreviousAuthDetails: true
          });
        }
      }
    };
    this.renderCaretButton = () => {
      const {
        apiKey,
        isMultipart,
        oAuthToken,
        securityTypes,
        selectedAuthType,
        usageTracker
      } = this.props;
      const {
        authPopoverIsOpen,
        isConfirming
      } = this.state;
      if (!securityTypes.length) {
        return null;
      }
      return /*#__PURE__*/_jsx(TryItPopover, {
        apiKey: apiKey,
        authPopoverIsOpen: authPopoverIsOpen,
        authType: selectedAuthType,
        doc: this.doc,
        isConfirming: isConfirming,
        isMultipart: isMultipart,
        oAuthToken: oAuthToken,
        onCancelButtonClick: this.onCancelButtonClick,
        onSendRequestButtonClick: this.onSendRequestButtonClick,
        securityTypes: securityTypes,
        usageTracker: usageTracker,
        children: /*#__PURE__*/_jsx(UIButton, {
          "aria-pressed": authPopoverIsOpen || isConfirming,
          className: "p-x-2",
          size: "extra-small",
          use: "tertiary-light",
          disabled: isMultipart,
          onClick: () => {
            this.setState({
              authPopoverIsOpen: !authPopoverIsOpen
            });
          },
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "downCarat",
            screenReaderText: I18n.text('developer-docs-shared-components.tryIt.dropdownButtonScreenReaderText')
          })
        })
      });
    };
    this.state = this.getDefaultState();
    this.doc = props.oasDocs.filter(d => d._id === props.docId)[0];
  }

  /**
   * @param {Object?} authDetails optional authentication details. If null, auth details
   * from redux store are used instead.
   */

  render() {
    const {
      responseStatus,
      isMultipart
    } = this.props;
    return /*#__PURE__*/_jsx(ResponsiveRenderer, {
      renderMobile: () => null,
      renderDesktop: () => /*#__PURE__*/_jsxs(UIButtonGroup, {
        children: [/*#__PURE__*/_jsx(UILoadingButton, {
          size: "extra-small",
          use: "tertiary-light",
          onClick: this.onTestCallButtonClick,
          loading: responseStatus.pending,
          resultIcon: null,
          disabled: isMultipart,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.tryIt.button"
          })
        }), this.renderCaretButton()]
      })
    });
  }
}
TryIt.propTypes = {
  apiKey: PropTypes.string,
  docId: PropTypes.string.isRequired,
  oasDocs: PropTypes.array.isRequired,
  oAuthToken: PropTypes.string,
  responseStatus: RequestStatusPropType.isRequired,
  securityTypes: PropTypes.arrayOf(AuthTypePropType).isRequired,
  selectedAuthType: AuthTypePropType,
  sendRequest: PropTypes.func.isRequired,
  isMultipart: PropTypes.bool.isRequired,
  usageTracker: PropTypes.object.isRequired
};
const mapStateToProps = (state, ownProps) => {
  return {
    apiKey: getApiKey(state),
    oAuthToken: getOAuthToken(state),
    responseStatus: getResponseStatus(state, ownProps),
    selectedAuthType: getAuthType(state, ownProps)
  };
};
const mapDispatchToProps = {
  sendRequest
};
export default connect(mapStateToProps, mapDispatchToProps)(TryIt);